/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, CircularProgress } from '@material-ui/core';

/**
 * region for styles*/
import { loadingProgressStyle } from './style/loadingProgressStyle';

class LoadingProgress extends Component {
    render() {
        const { classes } = this.props;
        return (
            <Grid className={classes.contentLoadingSearch} item xs={12}>
                <span>
                    <CircularProgress />
                </span>
                <br />
                <span>Loading...</span>
            </Grid>
        );
    }
}
LoadingProgress.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(loadingProgressStyle)(LoadingProgress);